import React from 'react';

import { useSportState } from '@atlas/core';

import useIsSwipeGrid from 'common/Widgets/Tournament/useIsSwipeGrid';
import EventLoader from 'components/Pages/EventLoader';
import EventSwipeGridLoader from 'components/Pages/EventSwipeGridLoader';

const SportLoader = props => {
  const { initialized, loading } = useSportState();

  const isSwipeGrid = useIsSwipeGrid();

  if (!initialized && loading) {
    return (
      <div className="category-container">
        <div className="tabs-list">
          <div className="tab-list-item skeleton-bg" />
          <div className="tab-list-item skeleton-bg" />
        </div>
        <div className="tournament-table">
          <div className="tournament tournament-scroll">
            <div className="tournament-header-info skeleton" />
            <div className="tournament-table-body-container">
              {isSwipeGrid ? <EventSwipeGridLoader /> : <EventLoader />}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return props.children;
};

export default SportLoader;
